import React from "react"
import { wrapPage } from "../aggregators/page"
import PageNotFoundContainer from "../containers/errors/PageNotFoundContainer"
import { DefaultLayout } from "../layouts/Default/DefaultLayout"
import { WrapPage } from "../root"

interface Props {
  rootData: any
}

const NotFoundPage = ({ rootData }: Props) => {
  return (
    <WrapPage rootData={rootData}>
      <DefaultLayout>
        <PageNotFoundContainer />
      </DefaultLayout>
    </WrapPage>
  )
}

export default NotFoundPage

export async function getStaticProps({ locale }: any) {
  return await wrapPage({
    locale,
    other: {
      revalidate: 10,
    },
  })
}
